import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu';

const HomePage = ({ userName, onLogout }) => {
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    // Animação de entrada
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const handleCardClick = (path) => {
    navigate(path);
  };

  const handleCardHover = (cardType) => {
    setActiveCard(cardType);
  };

  const handleCardLeave = () => {
    setActiveCard(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex flex-col overflow-hidden">

      {/* Header Moderno CEDISA */}
      <div className="relative z-10 bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
        <div className="flex items-center justify-between">
          {/* Título da página à esquerda */}
          <div className="flex-1">
            <h1 className="text-xl font-bold" style={{ color: '#090E3A' }}>
              Portal de Solicitações CEDISA
            </h1> 
            <p className="text-sm text-gray-600 font-medium">Recursos & Projetos • Departamento de TI</p>
          </div>
          
          {/* Logo CEDISA centralizada (botão para home) */}
          <div className="flex-1 flex justify-center">
            <button 
              onClick={() => navigate('/')}
              className="hover:opacity-80 transition-opacity duration-200"
            >
              <img src="cedisa-logo.png" alt="Cedisa Logo" className="h-10 drop-shadow-sm" />
            </button>
          </div>
          
          {/* Nome do usuário na direita */}
          <div className="flex-1 flex justify-end">
            <UserMenu userName={userName} onLogout={onLogout} />
          </div>
        </div>
      </div>

      {/* Aviso Importante */}
      <div className="bg-red-50 border-l-4 border-red-400 p-4 mx-6 mt-4 rounded-r-lg shadow-sm">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-red-700 font-semibold">
              <strong>ATENÇÃO:</strong> Esta é uma plataforma de <strong>SOLICITAÇÃO</strong>. 
              O envio de uma solicitação <strong>NÃO GARANTE</strong> que será aprovada pela CEDISA. 
              Todas as solicitações passam por análise e aprovação dos responsáveis.
            </p>
          </div>
        </div>
      </div>

      {/* Conteúdo Principal */}
      <div className="relative z-10 flex-1 flex items-center justify-center p-8">
        <div className="max-w-6xl w-full">
          {/* Hero Section CEDISA */}
          <div className={`text-center mb-16 transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>     
            
            <h2 className="text-5xl font-bold mb-6 leading-tight" style={{ color: '#090E3A' }}>
              Portal de Solicitações
              <br />
              <span style={{ color: '#E85C1E' }}>
                CEDISA
              </span>
            </h2>
            
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8">
              Solicite com facilidade recursos e projetos para o seu setor.
            </p>

            {/* Estatísticas CEDISA */}
            <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto mb-12">
              <div className="text-center">
                <div className="text-3xl font-bold mb-2" style={{ color: '#090E3A' }}>100%</div>
                <div className="text-sm text-gray-600">Digital</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2" style={{ color: '#E85C1E' }}>24/7</div>
                <div className="text-sm text-gray-600">Disponível</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold mb-2" style={{ color: '#090E3A' }}>∞</div>
                <div className="text-sm text-gray-600">Possibilidades</div>
              </div>
            </div>
          </div>

          {/* Cards Principais */}
          <div className={`grid lg:grid-cols-2 gap-8 items-stretch transition-all duration-1000 delay-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            
            {/* Card Solicitar Recursos CEDISA */}
            <div 
              onClick={() => handleCardClick('/recursos')}
              onMouseEnter={() => handleCardHover('recursos')}
              onMouseLeave={handleCardLeave}
              className={`group cursor-pointer bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-gray-200 overflow-hidden relative flex flex-col h-full ${
                activeCard === 'recursos' ? 'scale-105 shadow-2xl' : ''
              }`}
            >
              {/* Background Gradient CEDISA */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'linear-gradient(135deg, rgba(232, 92, 30, 0.05) 0%, rgba(9, 14, 58, 0.05) 100%)' }}></div>
              
              <div className="relative z-10 p-10 flex-1 flex flex-col">
                {/* Conteúdo */}
                <h3 className="text-2xl font-bold mb-4 transition-colors duration-300" style={{ color: '#090E3A' }}>
                  Solicitar Recursos
                </h3>
                <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                  Gerencie licenças e equipamentos de forma simplificada e organizada. 
                  O portal realiza cálculos automáticos, gera relatórios detalhados 
                  e oferece controle total dos custos para facilitar a gestão de recursos da sua equipe.
                </p>

                {/* Features */}
                <div className="space-y-4 flex-1">
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(232, 92, 30, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#E85C1E' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Cálculo automático de custos</span>
                  </div>
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(232, 92, 30, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#E85C1E' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Gestão inteligente de colaboradores</span>
                  </div>
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(232, 92, 30, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#E85C1E' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Relatórios em tempo real</span>
                  </div>
                </div>
              </div>

              {/* CTA - Sempre embaixo */}
              <div className="relative z-10 px-10 pb-10 border-t border-gray-200">
                <div className="flex items-center justify-between pt-6">
                  <div className="flex items-center font-semibold transition-colors duration-300" style={{ color: '#E85C1E' }}>
                    <span className="text-lg">Acessar Sistema</span>
                    <svg className="w-6 h-6 ml-3 group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                  <div className="text-sm text-gray-500 transition-colors duration-300">
                    Clique para continuar
                  </div>
                </div>
              </div>

              {/* Barra de Progresso CEDISA */}
              <div className="h-2 transition-all duration-500" style={{ background: 'linear-gradient(90deg, #E85C1E 0%, #ff7a3d 100%)' }}></div>
            </div>

            {/* Card Propor Projeto CEDISA */}
            <div 
              onClick={() => handleCardClick('/projetos')}
              onMouseEnter={() => handleCardHover('projetos')}
              onMouseLeave={handleCardLeave}
              className={`group cursor-pointer bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-gray-200 overflow-hidden relative flex flex-col h-full ${
                activeCard === 'projetos' ? 'scale-105 shadow-2xl' : ''
              }`}
            >
              {/* Background Gradient CEDISA */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'linear-gradient(135deg, rgba(9, 14, 58, 0.05) 0%, rgba(232, 92, 30, 0.05) 100%)' }}></div>
              
              <div className="relative z-10 p-10 flex-1 flex flex-col">
                {/* Conteúdo */}
                <h3 className="text-2xl font-bold mb-4 transition-colors duration-300" style={{ color: '#090E3A' }}>
                  Propor Projeto
                </h3>
                <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                  Transforme suas ideias em propostas de projetos bem estruturadas. 
                  Um formulário guiado que te ajuda a organizar todos os detalhes importantes 
                  para que sua proposta seja avaliada de forma completa pela equipe de TI.
                </p>

                {/* Features */}
                <div className="space-y-4 flex-1">
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(9, 14, 58, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#090E3A' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Formulário passo a passo intuitivo</span>
                  </div>
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(9, 14, 58, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#090E3A' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Organize objetivos, prazos e recursos necessários</span>
                  </div>
                  <div className="flex items-center text-gray-600 transition-colors duration-300">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3 transition-colors duration-300" style={{ backgroundColor: 'rgba(9, 14, 58, 0.1)' }}>
                      <svg className="w-4 h-4" style={{ color: '#090E3A' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="font-medium">Gere automaticamente um relatório completo da sua proposta</span>
                  </div>
                </div>
              </div>

              {/* CTA - Sempre embaixo */}
              <div className="relative z-10 px-10 pb-10 border-t border-gray-200">
                <div className="flex items-center justify-between pt-6">
                  <div className="flex items-center font-semibold transition-colors duration-300" style={{ color: '#090E3A' }}>
                    <span className="text-lg">Criar Proposta</span>
                    <svg className="w-6 h-6 ml-3 group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </div>
                  <div className="text-sm text-gray-500 transition-colors duration-300">
                    Clique para continuar
                  </div>
                </div>
              </div>

              {/* Barra de Progresso CEDISA */}
              <div className="h-2 transition-all duration-500" style={{ background: 'linear-gradient(90deg, #090E3A 0%, #1a2051 100%)' }}></div>
            </div>
          </div>

          {/* Footer Informativo CEDISA */}
          <div className={`mt-16 text-center transition-all duration-1000 delay-500 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 max-w-4xl mx-auto border border-gray-200 shadow-lg">
              <div className="flex items-center justify-center mb-6">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mr-4 shadow-lg" style={{ background: 'linear-gradient(135deg, #090E3A 0%, #1a2051 100%)' }}>
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h4 className="text-2xl font-bold" style={{ color: '#090E3A' }}>
                  Como Funciona
                </h4>
              </div>
              
              <div className="grid md:grid-cols-2 gap-8 text-left">
                <div className="space-y-4">
                  <h5 className="text-lg font-semibold flex items-center" style={{ color: '#090E3A' }}>
                    <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3" style={{ backgroundColor: 'rgba(9, 14, 58, 0.1)' }}>
                      <span className="font-bold text-sm" style={{ color: '#090E3A' }}>1</span>
                    </div>
                    Solicitações de Recursos
                  </h5>
                  <p className="text-gray-600 ml-9">
                    Para novos colaboradores ou funcionários existentes que precisam de licenças e equipamentos. 
                    Calcula automaticamente todos os custos envolvidos.
                  </p>
                </div>
                
                <div className="space-y-4">
                  <h5 className="text-lg font-semibold flex items-center" style={{ color: '#090E3A' }}>
                    <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3" style={{ backgroundColor: 'rgba(232, 92, 30, 0.1)' }}>
                      <span className="font-bold text-sm" style={{ color: '#E85C1E' }}>2</span>
                    </div>
                    Propostas de Projetos
                  </h5>
                  <p className="text-gray-600 ml-9">
                    Para novas iniciativas que requerem desenvolvimento ou implementação pela TI. 
                    Formulário guiado que te ajuda a detalhar sua proposta de forma completa e organizada.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;